import { createApp } from "vue";
import App from "./App.vue";
import VueApexCharts from "vue3-apexcharts";
import router from "./router";
import { createPinia } from "pinia";
import GlobalFunctions from "@/plugins/globalFunctions";
import registerGlobalComponents from "@/plugins/globalComponents";
import "./assets/style/index.css";

const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(VueApexCharts);

app.use(pinia);
app.use(GlobalFunctions);
app.use(registerGlobalComponents);

app.mount("#app");
